import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** One chat bubble, as returned by POST /getMessages. */
export interface ChatMessage {
  id?: number;
  sender: number;
  receiver: number;
  message: string;
  read?: number;
  created_at?: string | Date;
  updated_at?: string | Date;
  [key: string]: any;
}

/** One row in the left conversation list, as returned by GET /chats. */
export interface ChatThread {
  login_id: number;
  pkid_name: string;
  username: string;
  login_type?: { typename: string };
  message?: ChatMessage[];
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  /** Kept so existing code reading chat.env keeps compiling. */
  readonly env = environment;
  private readonly baseUrl = environment.url;

  constructor(private http: HttpClient) { }

  /** Everyone the current user can chat with. GET /chats */
  getThreads(): Observable<ChatThread[]> {
    return this.http.get<ChatThread[]>(this.baseUrl + '/chats');
  }

  /** History with one person. POST /getMessages { login_id } */
  getMessages(loginId: number): Observable<ChatMessage[]> {
    return this.http.post<ChatMessage[]>(this.baseUrl + '/getMessages', { login_id: loginId });
  }

  /** @deprecated Use getMessages() instead. Kept for old callers. */
  chats(loginId: number): Observable<ChatMessage[]> {
    return this.getMessages(loginId);
  }

  /** @deprecated Use getThreads() instead. Kept for old callers. */
  getChat(): Observable<ChatThread[]> {
    return this.getThreads();
  }

}
